export  function getCar(){
	
	return `1.807916,2.738693
1.356779,2.914404
0.9928357,2.907641
0.7381389,2.714691
0.6114669,2.581822
0.2827546,2.083879
0.1603612,1.868659
0.127175,1.80622
-1.020392,0.05385205
-1.203527,-0.4413868
-1.169994,-0.6193634
-1.000449,-0.7975594
-0.7060224,-1.042129
-0.3784112,-1.224256
-0.08005434,-1.310759
0.09870892,-1.245614
0.4322654,-0.9344237
1.596032,0.8333572
1.658692,0.9361859
1.792001,1.081543
2.187871,1.73598
2.25053,1.838809
2.298563,1.989449
2.222724,2.374089
`;
}